import AlertComponent from "@atoms/alert/alert.component";
import FormBuilderComponent from "@molecules/form-builder/form-builder.component";
import UnAuthFormWrapperComponent from "@src/components/organisms/unauth-form-wrapper/unauth-form-wrapper.component";
import React from "react";

const RefreshPasswordTemplate = ({
  templateModal: { formTriggers, user, alertMessage },
  templateEvents: { handleSubmit, onSubmitTrigger },
}) => {
  return (
    <UnAuthFormWrapperComponent
      heading={user?.name || ""}
      message={`Your password has been expired, please enter the password again to login`}
    >
      <FormBuilderComponent
        formType="group"
        submitTrigger={formTriggers.submitTrigger}
        isVertical={true}
        onSubmit={handleSubmit}
        inputFields={[
          {
            type: "PASSWORD",
            label: "Password",
            id: "password",
            name: "password",
            value: "",
            isVertical: true,
            placeholder: "Enter the password",
            validations: [
              {
                type: "REQUIRED",
                message: "Password is required !",
              },
            ],
          },
        ]}
      />

      <button
        style={{ marginTop: 20 }}
        className="btn btn-primary w-100"
        type="button"
        onClick={onSubmitTrigger}
      >
        Submit
      </button>

      {alertMessage && (
        <div style={{ marginTop: 16 }}>
          <AlertComponent
            type={alertMessage.type}
            message={alertMessage.message}
          />
        </div>
      )}
    </UnAuthFormWrapperComponent>
  );
};

export default RefreshPasswordTemplate;
